import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import type { RootState } from "~/store";

const ONCE_SHOW_POPUP_KEY = "reqxign-once-show-popup-20260413";

// 表示終了日時: 2026/5/15 23:59 JST (UTC+9) = 2026/5/15 14:59 UTC
const DISPLAY_END_TIMESTAMP = Date.UTC(2026, 4, 15, 14, 59, 0);

export const useOnceShowPopup = () => {
  const [shouldShow, setShouldShow] = useState(false);
  const { status } = useSelector((state: RootState) => state.auth);

  const getLastShownTimestamp = useCallback((): number => {
    const stored = localStorage.getItem(ONCE_SHOW_POPUP_KEY);
    return stored ? parseInt(stored, 10) : 0;
  }, []);

  const markAsShown = useCallback((): void => {
    const now = Date.now();
    localStorage.setItem(ONCE_SHOW_POPUP_KEY, now.toString());
    setShouldShow(false);
  }, []);

  useEffect(() => {
    if (status === "idle") {
      // 表示終了日時を過ぎたら表示しない
      if (Date.now() >= DISPLAY_END_TIMESTAMP) {
        setShouldShow(false);
        return;
      }
      const lastShown = getLastShownTimestamp();
      if (lastShown === 0) {
        setShouldShow(true);
      }
    }
  }, [status, getLastShownTimestamp]);

  return { shouldShow, markAsShown };
};
